/**
 * Login Page Component
 * 
 * Simple login page that redirects to Auth0 login.
 * This is a temporary page for Stage 6 - full login UI will be in Stage 7.
 */

import { login } from "../../services/authApi";
import "./loginPage.css";

export function LoginPage() {
  const handleLogin = () => {
    // Redirect to Auth0 login via backend
    login(window.location.href);
  };

  return (
    <div className="login-page">
      <div className="login-page__container">
        <div className="login-page__brand">
          <img
            src="/assets/zakyam-logo.png"
            alt="Zakyam AI Trader"
            className="login-page__logo"
          />
          <h1 className="login-page__title">Zakyam AI Trader</h1>
          <p className="login-page__subtitle">
            Autonomous AI execution, news intelligence, and capital oversight
          </p>
        </div>
        
        <div className="login-page__content">
          <h2 className="login-page__heading">Welcome</h2>
          <p className="login-page__description">
            Sign in to access your trading dashboard
          </p>
          
          <button
            type="button"
            className="login-page__button"
            onClick={handleLogin}
          >
            Sign In with Auth0
          </button>
        </div>
      </div>
    </div>
  );
}

